import { render, staticRenderFns } from "./AvatarEdit.vue?vue&type=template&id=e2f9c052&scoped=true&"
import script from "./AvatarEdit.vue?vue&type=script&lang=js&"
export * from "./AvatarEdit.vue?vue&type=script&lang=js&"
import style0 from "./AvatarEdit.vue?vue&type=style&index=0&id=e2f9c052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f9c052",
  null
  
)

export default component.exports